import { render } from "./Info.vue?vue&type=template&id=a06c4f64"
const script = {}

import "./Info.vue?vue&type=style&index=0&id=a06c4f64&lang=scss"

import exportComponent from "/Users/gray/Desktop/Work_temp/經貿網/web/project/rotate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__